// extracted by css-extract-rspack-plugin
export default {"lens":"XDfild8B","overlayed":"MGJbXTJc"};